<div class="row">
  <div>
    <div class="questionProgress"></div>
    <div id="questionContainer" class="questionContainer" data-question-container="one_at_a_time">
      <span class="loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </div>
  </div>
</div>